<template>
  <el-form
    v-if="props.formItem.length > 0"
    ref="formRef"
    :scroll-to-error="true"
    :model="props.model"
    :label-position="props.position"
    :label-width="props.width || 100 / 192 + 'rem'"
    :rules="props.rules"
  >
    <el-row :gutter="props.gutter">
      <el-col
        v-for="(item, index) in props.formItem"
        :key="index"
        :span="item.span || props.allSpan || 12"
        v-show="showItem(item)"
        :class="{'divider':item.type=='divider'}"
      >
        <el-form-item  :label="item.label" :label-width="item.width" :prop="item.prop">
          <template #label="{ label }">
            <el-tooltip
              :content="label"
              placement="top"
              popper-class="commonPopper"
              :disabled="label.length <= (props.tooltipNum || 6)"
            >
              <span class="label-item">{{ label }}</span>
            </el-tooltip>
          </template>
          <template v-if="item.type === 'input'">
            <el-input
              v-model.trim="props.model[item.prop]"
              :disabled="item.disabled&&item.disabled() || props.operation === 'detail'"
              :readonly="item.readonly || false"
              :placeholder="item.placeholder || `请输入${item.label}`"
              @input="(e) => handleChange(e, item.prop)"
              clearable
            />
            <!-- 输入框后面的tips提示 -->
            <div v-if="item.tips" class="form-tip">
              <el-tooltip :content="item.tips">
                <el-icon size="20">
                  <InfoFilled />
                </el-icon>
              </el-tooltip>
            </div>
          </template>
          <template v-if="item.type === 'password'">
            <el-input
              v-model.trim="props.model[item.prop]"
              type="password"
              show-password
              :disabled="item.disabled&&item.disabled()  || props.operation === 'detail'"
              :readonly="item.readonly || false"
              :placeholder="item.placeholder || `请输入${item.label}`"
              @input="(e) => handleChange(e, item.prop)"
              clearable
            />
          </template>
          <template v-else-if="item.type === 'number'">
            <el-input-number
              v-model="props.model[item.prop]"
              :disabled="item.disabled&&item.disabled()  || props.operation === 'detail'"
              :max="item.max"
              :min="item.min || 0"
              @change="(e) => handleChange(e, item.prop)"
              clearable
            />
          </template>
          <template v-else-if="item.type === 'select'">
            <async-select
              v-model="props.model[item.prop]"
              :promise-fn="item.optionsPro"
              :placeholder="
                    item.placeholder || `请选择${item.label}`
                  "
              :disabled="item.disabled&&item.disabled()  || false"
              :allowCreate="item.allowCreate || false"
              v-bind="item.props"
            ></async-select>
          </template>
          <template v-else-if="item.type === 'radio'">
            <el-radio-group
              v-model="props.model[item.prop]"
              :disabled="item.disabled&&item.disabled()  || props.operation === 'detail'"
              @change="(e) => handleChange(e, item.prop)"
            >
              <el-radio
                v-for="its in item.options"
                :key="its.value"
                :value="its.value"
              >{{ its.label }}</el-radio>
            </el-radio-group>
          </template>
          <template v-else-if="item.type === 'checkbox'">
            <el-checkbox-group
              v-model="props.model[item.prop]"
              :disabled="item.disabled&&item.disabled()  || props.operation === 'detail'"
              @change="(e) => handleChange(e, item.prop)"
            >
              <el-checkbox
                v-for="its in item.options"
                :key="its.value"
                :value="its.value"
              >{{ its.label }}</el-checkbox>
            </el-checkbox-group>
          </template>
          <template v-else-if="item.type === 'time'">
            <el-time-select
              v-model="props.model[item.prop]"
              :disabled="item.disabled&&item.disabled()  || props.operation === 'detail'"
              :end="item.end || '18:00'"
              :max-time="item.maxTime"
              :min-time="item.minTime"
              :placeholder="item.placeholder"
              :start="item.start || '08:30'"
              :step="item.step || '00:30'"
              clearable
              format="ss:mm"
              @change="(e) => handleChange(e, item.prop)"
            />
          </template>
          <template v-else-if="item.type === 'timerange'">
            <el-time-picker
              v-model="props.model[item.prop]"
              :disabled="item.disabled&&item.disabled()  || props.operation === 'detail'"
              :start-placeholder="
                item.startPlaceholde || `请选择开始${item.label}`
              "
              :end-placeholder="
                item.endPlaceholder || `请选择结束${item.label}`
              "
              :range-separator="item.rangeSeparator || '-'"
              clearable
              format="HH:mm:ss"
              is-range
              @change="(e) => handleChange(e, item.prop)"
            />
          </template>
          <template
            v-else-if="
              ['date', 'week', 'month', 'year', 'dates'].includes(item.type)
            "
          >
            <el-date-picker
              v-model="props.model[item.prop]"
              :disabled-date="item.disabledDate"
              :disabled="item.disabled&&item.disabled()  || props.operation === 'detail'"
              :format="item.format"
              :placeholder="item.placeholder || `请选择${item.label}`"
              :shortcuts="item.shortcuts"
              :time-format="item.timeFormat || 'HH:mm'"
              :type="item.type"
              :value-format="item.valueFormat || 'YYYY-MM-DD'"
              @change="(e) => handleChange(e, item.prop)"
            />
          </template>
          <template v-else-if="item.type === 'daterange' || item.type === 'monthrange'">
            <el-date-picker
              v-model="props.model[item.prop]"
              :disabled-date="item.disabledDate"
              :disabled="item.disabled&&item.disabled()  || props.operation === 'detail'"
              :end-placeholder="
                item.endPlaceholder || `请选择结束${item.label}`
              "
              :format="item.format || 'YYYY-MM-DD'"
              :shortcuts="item.shortcuts"
              :start-placeholder="
                item.startPlaceholder || `请选择开始${item.label}`
              "
              :type="item.type"
              :value-format="item.valueFormat || 'YYYY-MM-DD'"
              @change="(e) => handleChange(e, item.prop)"
            />
          </template>
          <template v-else-if="item.type === 'datetime'">
            <el-date-picker
              v-model="props.model[item.prop]"
              :date-format="item.dateFormat || 'YYYY-MM-DD'"
              :disabled-date="item.disabledDate"
              :disabled="item.disabled&&item.disabled()  || props.operation === 'detail'"
              :format="item.format"
              :placeholder="item.placeholder || `请选择${item.label}`"
              :shortcuts="item.shortcuts"
              :time-format="item.timeFormat || 'HH:mm:ss'"
              :value-format="item.valueFormat || 'YYYY-MM-DD HH:mm:ss'"
              type="datetime"
              @change="(e) => handleChange(e, item.prop)"
            />
          </template>
          <template v-else-if="item.type === 'dateTimeRange'">
            <el-date-picker
              v-model="props.model[item.prop]"
              :date-format="item.dateFormat || 'YYYY-MM-DD'"
              :value-format="item.valueFormat || 'YYYY-MM-DD HH:mm:ss'"
              :disabled-date="item.disabledDate"
              :disabled="item.disabled&&item.disabled()  || props.operation === 'detail'"
              :format="item.format"
              :range-separator="item.rangeSeparator || 'To'"
              :shortcuts="item.shortcuts"
              :start-placeholder="
                item.startPlaceholder || `请选择开始时间`
              "
              :end-placeholder="
                item.endPlaceholder || `请选择结束时间`
              "
              :time-format="item.timeFormat || 'HH:mm:ss'"
              type="datetimerange"
              @change="(e) => handleChange(e, item.prop)"
            />
          </template>
          <template v-else-if="item.type === 'textarea'">
            <el-input
              v-model.trim="props.model[item.prop]"
              type="textarea"
              :disabled="item.disabled&&item.disabled()  || props.operation === 'detail'"
              :placeholder="item.placeholder || `请输入${item.label}`"
              :show-word-limit="item.showWordLimit || false"
              :resize="item.resize || 'none'"
              :rows="item.rows || 4"
              @input="(e) => handleChange(e, item.prop)"
              clearable
            />
          </template>
          <template v-else-if="item.type === 'switch'">
            <el-switch
              v-model="props.model[item.prop]"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="item.options.activeValue"
              :inactive-value="item.options.inactiveValue"
              @change="(e) => handleChange(e, item.prop)"
            ></el-switch>
          </template>
          <template v-else-if="item.type === 'text'">
            <span>{{ props.model[item.prop]||'--' }}</span>
          </template>
          <template v-else-if="item.type === 'color'">
            <el-input v-model="props.model[item.prop]" type="color"></el-input>
          </template>
          <template v-else-if="item.type === 'upload'">
            <div style="display: flex;flex-direction: column;">
              <comUpload
                v-model="props.model[item.prop]"
                :action="item.url"
                accept="image/*"
                :max-size="item.maxSize ?? 0"
                :limit-width="item.limitWidth || 0"
                :limit-height="item.limitHeight || 0"
                :fullImgUrl="item.fullImgUrl"
                :uploadUrl="item.url"
                :disabled="item.disabled&&item.disabled()  || props.operation === 'detail'"
                @change="handleFileChange"
                @error="handleError"
              ></comUpload>
              <span style="font-size:10px;color: blue;">{{ item.tips }}</span>
            </div>
          </template>
          <template v-else-if="item.type === 'mutipleUpload'">
            <div style="display: flex;flex-direction: column;">
              <comMutipleUpload
                  v-model="props.model[item.prop]"
                  :action="item.url"
                  accept="image/*"
                  :max-size="10"
                  :fullImgUrl="item.fullImgUrl"
                  :uploadUrl="item.url"
                  :limit="item.limit"
                  :disabled="item.disabled&&item.disabled()  || props.operation === 'detail'"
                  @change="handleFileChange"
                  @error="handleError"
                ></comMutipleUpload>
                <span style="font-size:10px;color: blue;">{{ item.tips }}</span>
            </div>
  
          </template>
          <template v-else-if="item.type === 'custom'">
            <slot :name="item.prop" :item="item" />
          </template>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script lang="ts" setup>
import {
  ref,
  withDefaults,
  defineProps,
  defineEmits,
  defineExpose,
  getCurrentInstance
} from "vue";
import { ElForm, ElMessage } from "element-plus";
import AsyncSelect from "../comList/components/async-select.vue";
import comUpload from "../comUpload/index.vue";
import comMutipleUpload from '../comMutipleUpload/index.vue'
const { proxy } = getCurrentInstance() as any;

const emits = defineEmits(["handleChange"]);

interface propType {
  model: Record<string, any>;
  formItem: Array<Record<string, any>>;
  position?: "left" | "top" | "right";
  rules?: Record<string, any>;
  gutter?: number;
  height?: number;
  width?: string;
  operation?: string;
  tooltipNum?: number;
  allSpan?: number;
}

const formRef = ref<InstanceType<typeof ElForm>>();

const props = withDefaults(defineProps<propType>(), {
  model: () => ({}),
  formItem: () => [],
  position: "left",
  rules: () => ({}),
  gutter: 0,
  height: 32,
  operation: ""
});

const handleChange = (e: any, prop: string, type?: string): void => {
  emits("handleChange", e, prop, proxy.$refs?.[prop + "Ref"]);
};

const validData = async (cb): Promise<boolean> | undefined => {
  if (cb) {
    formRef.value!.validate(cb);
  } else {
    const result = await formRef.value!.validate();
    if (!result) {
      scrollToFirstError(formRef.value);
    }
    return result;
  }
};

const resetForm = (): void => {
  formRef.value!.resetFields();
};

const clearValidate = (): void => {
  formRef.value!.clearValidate();
};

const handleFileChange = fileInfo => {
};

const handleError = message => {
  ElMessage.error(message);
};

// 在表单提交或校验时调用此方法
const scrollToFirstError = formRef => {
  // 获取第一个错误的字段名
  const firstErrorField = Object.keys(formRef.fields).find(field => {
    return formRef.fields[field].validateState === "error";
  });

  if (firstErrorField) {
    // 获取对应的 DOM 元素
    const el = formRef.fields[firstErrorField].$el;

    // 滚动到该元素
    el.scrollIntoView({
      behavior: "smooth", // 平滑滚动
      block: "center" // 垂直居中
    });

    // 可选：添加高亮效果
    el.classList.add("error-highlight");
    setTimeout(() => {
      el.classList.remove("error-highlight");
    }, 2000);
  }
};

const showItem = item => {
  // 特殊字段不能生效页面
  if(item.type == "radio"&&item.options.length==0){
    return true
  }
  if (
    item.type == "radio" &&
    item.prop !== "buyAppMachineOrSeconds" &&
    item.prop !== "buyPcMachineOrSeconds"
  ) {
    props.model[item.prop] = props.model[item.prop] || item.options[0].value;
  }

  return item.show ? item.show(props.model) : true;
};

defineExpose({ resetForm, validData, clearValidate });
</script>

<style lang="scss" scoped>
.el-form {
  .divider {
    border-top: 1px dotted #ddd;
    height: 0;
    margin: 15px 0;
  }
  :deep(.el-form-item) {
    margin-bottom: 15px;
    .el-form-item__label {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.9);
      .label-item {
        display: inline-block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .el-form-item__content {
      flex-wrap: nowrap;
      .el-input {
        .el-input__wrapper {
          .el-input__inner {
            font-size: 12px;
            color: #000;
            &::placeholder {
              color: rgba(0, 0, 0, 0.4);
            }
            &:disabled,
            &[disabled] {
              -webkit-text-fill-color: rgba(#000, 0.7);
            }
          }
        }
      }
      .el-select {
        .el-select__wrapper {
          .el-select__selected-item {
            .el-select__input {
              font-size: 12px;
              color: #000;
            }
          }
          .el-select__placeholder.is-transparent {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.4);
          }
          .el-select__placeholder {
            font-size: 12px;
            color: #000;
          }
        }
      }
      .el-cascader,
      .el-input-number,
      .el-date-editor {
        width: 100%;
      }
      .el-textarea {
        .el-textarea__inner {
          font-size: 12px;
          color: #000;
          &::placeholder {
            color: rgba(0, 0, 0, 0.4);
          }
        }
      }
    }
  }
}
.error-highlight {
  animation: highlight 2s;
}
.form-tip {
  // position: absolute;
  // right: -25px;
  // top: 50%;
  // transform: translateY(-50%);
  // color: #909399;
  // cursor: pointer;
  width: 20px;
  height: 20px;
  margin-left: 5px;
}
@keyframes highlight {
  0% {
    background-color: #fff2f0;
  }
  50% {
    background-color: #ffccc7;
  }
  100% {
    background-color: #fff2f0;
  }
}
</style>
